// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { generateId } from './api/utility';
import Icon from './form/Icon';

const Wrapper = styled.div`
    position: ${({ draggable }) => draggable ? 'fixed' : 'block'};
    display: flex;
    flex-direction: column;
    z-index: ${({ draggable }) => draggable ? '1000' : '1'};
`
const DragTab = styled.div`
    background: #ebebff;
    padding: 0.2em;
    border-radius: 0.5rem 0.5rem 0 0;
    display: flex;
    justify-content: center;
`

const Draggable = ({ open, updateOpenState, accountdetails, children, ...props }) => {
    const [draggable, setDraggable] = useState(false);
    const id = generateId();

    useEffect(() => {
        dragElement(document.getElementById(id));

        function dragElement(elmnt) {
            var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
            if (document.getElementById(elmnt.id + 'header')) {
                document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;
            } else {
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();

                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                elmnt.style.top = draggable ? (elmnt.offsetTop - pos2) + "px" : '100px';
                elmnt.style.left = draggable ? (elmnt.offsetLeft - pos1) + "px" : '100px';
            }

            function closeDragElement() {
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }
    }, [draggable])

    return (
        <Wrapper
            draggable={draggable}
            id={id}
            style={{ top: '100px', left: '100px' }}
        >
            <DragTab
                id={id + 'header'}
            >
                <span>{draggable ? 'Dragging' : 'Pinned'}</span>
                <Icon onClick={() => setDraggable(!draggable)} icon='pin' style={{ cursor: 'pointer' }} />
            </DragTab>
            {children}
        </Wrapper>
    )
}

export default Draggable;
